"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useAuth } from "@/context/AuthContext";
import { LogoLoadingIndicator } from "@/components/common/LogoLoadingIndicator";
import { getLoginRedirectPage } from "@/utils/common";

export default function HomePage() {
  const router = useRouter();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!loading) {
      if (user) {
        // User is authenticated, redirect to appropriate page based on permissions
        const redirectPage = getLoginRedirectPage(user);
        router.push(redirectPage);
      } else {
        // User is not authenticated, redirect to login
        router.push("/login");
      }
    }
  }, [user, loading, router]);

  // Show loading spinner while checking authentication status
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      {loading && <LogoLoadingIndicator open={loading} />}
    </div>
  );
}
